import { z } from 'zod';
export const RENEWAL_STATUSES = [
    'upcoming',
    'contacted',
    'renewing',
    'renewed_here',
    'renewed_elsewhere',
    'tenant_leaving',
    'unknown',
];
export const renewalStatusSchema = z.object({
    status: z.enum(RENEWAL_STATUSES),
    notes: z.string().max(2000).optional(),
});
/** The broker attests that the tenant and the owner agreed to hear from them (R17). */
export const notifyPartiesSchema = z.object({ attested: z.literal(true) });
/** The owner switches monthly rent reminders on, confirming the tenant knows (R17). */
export const rentOptInSchema = z.object({
    dayOfMonth: z.number().int().min(1).max(31),
    tenantAware: z.literal(true),
});
//# sourceMappingURL=renewal.js.map